[ {
    "display": "true",
    "ui_columnname": "Date/Time",
    "db_columnname": "StartDtTm",
    "datatype": "String",
    "mappingkey": "startTime",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Description",
    "db_columnname": "Process_Remark",
    "datatype": "String",
    "mappingkey": "Process_Remark",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Report Date",
    "db_columnname": "Report_Date",
    "datatype": "String",
    "mappingkey": "Report_Date",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "File Name",
    "db_columnname": "File_Name",
    "datatype": "String",
    "mappingkey": "File_Name",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "File Size",
    "db_columnname": "File_Size",
    "datatype": "String",
    "mappingkey": "File_Size",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "File Row #",
    "db_columnname": "File_Record_Count",
    "datatype": "String",
    "mappingkey": "File_Record_Count",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Rejected Row #",
    "db_columnname": "Rejected_Record_Count",
    "datatype": "String",
    "mappingkey": "Rejected_Record_Count",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Success Flag",
    "db_columnname": "Success_Flag",
    "datatype": "String",
    "mappingkey": "Success_Flag",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    },{
    "display": "true",
    "ui_columnname": "Activity Details",
    "db_columnname": "UDFO1",
    "datatype": "String",
    "mappingkey": "UDFO1",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "End Date/Time",
    "db_columnname": "FinishDtTm",
    "datatype": "String",
    "mappingkey": "FinishDtTm",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }, {
    "display": "true",
    "ui_columnname": "Validation Status",
    "db_columnname": "Validation_Process_Flag",
    "datatype": "String",
    "mappingkey": "Validation_Process_Flag",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "false",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
    }]